// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"_c223d4c","skeletonRow":"_0fbf67b","skeletonColumn":"_d29f5bb","skeletonContainer":"_3691ee9","singleTable":"_c846d27"};